/**
 * Captura global de beforeinstallprompt (Chrome/Edge/Android). El evento se
 * dispara una sola vez y antes de que React monte, así que se guarda aquí y
 * InstallPrompt.tsx se suscribe.
 */

export interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

type Listener = (event: BeforeInstallPromptEvent) => void;

let deferredEvent: BeforeInstallPromptEvent | null = null;
const listeners = new Set<Listener>();

export function initInstallEventCapture(): void {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault(); // suprime la mini-barra del navegador
    deferredEvent = event as BeforeInstallPromptEvent;
    listeners.forEach((listener) => listener(deferredEvent as BeforeInstallPromptEvent));
  });
}

export function getDeferredInstallEvent(): BeforeInstallPromptEvent | null {
  return deferredEvent;
}

export function subscribeInstallEvent(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function clearDeferredInstallEvent(): void {
  deferredEvent = null;
}
